import appStore from 'store';
import api from './api';
import { PAGINATION } from 'common/config';

const store = {
  namespaced: true,
  state: {
    datas: [],
    currencyIntroductionList: [],
    currencyTransferList: [],
    introductionDetail: {

    },
    detailDialogVisible: false,
    pagination: PAGINATION,
    totalCount: 0
  },
  getters: {

  },
  mutations: {
    setCurrencyIntroductionList(state, payload) {
      state.currencyIntroductionList = payload.list.slice();
      state.totalCount = payload.totalCount;
    },
    setCurrencyTransferList(state, payload) {
      state.currencyTransferList = payload.list.slice();
      state.totalCount = payload.totalCount;
    },
    toggleDetailDialogVisible(state, payload) {
      state.detailDialogVisible = payload;
    },
    setDetail(state, payload) {
      state.introductionDetail = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setList(state, payload) {
      payload.list.filter(item => {
        if (item.confKey == 'SUPPORT_TRANSFER_ACCOUNT_TYPE') {
          state.datas = JSON.parse(item.confValue)
        }
      });
      // state.datas = payload.list;
      // state.totalCount = payload.totalCount;
    },
  },
  actions: {
    reqList({ commit }, query) {
      api.reqList(query).then((res) => {
        commit('setList', res.data);
        // commit('setPagination', { size: query.size, page: query.page });
      });
    },
    getList({ commit }, data) {
      api.getCurrencyTransferList(data).then(res => {
        commit('setPagination', { page: data.page, size: data.size })
        commit('setCurrencyTransferList', res.data)
      })

    },
    updateOrAdd({ commit }, data) {
      return api.updateOrAdd(data).then(res => {
        return res
      })
    },
    delOne({ commit }, id) {
      return api.delOne(id).then(res => {
        return res
      })
    },

    detail({ commit }, id) {
      return api.getCurrencyDetail(id).then(({ data }) => {
        commit('setDetail', data);
      });
    },

  }
};

appStore.registerModule('currencyTransferSetting', store);
